import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { isFileAllowed } from "./consts";

export const setTimeCreate = (date) => {
  return date
    ? date.split(" ")[0].split("-").reverse().join(".") +
        ", " +
        date.split(" ")[1].slice(0, 5)
    : "";
};

export const statusType = (title) => {
  return title === "Черновик" // Черновик
    ? "draft"
    : title === "На проверке" // На проверке
    ? "checking"
    : title === "Согласован" // Согласован
    ? "published"
    : title === "Заблокирован" // Заблокирован
    ? "blocked"
    : title === "Отклонён"
    ? "rejected"
    : title === "Довнести документы"
    ? "add"
    : "";
};

// Возвращает объект со значениями "доступен ли отклик", и если нет, то комментарий
export const applyInfo = function (...data) {
  const [candidate, titles] = data;
  let isApplyDisabled = true;
  let comment = "";

  switch (titles && candidate && titles[candidate.status_id]) {
    // Если статус кандидата == "Черновик"
    case "Черновик":
      isApplyDisabled = true;
      comment = `Нет возможности откликнуться кандидатом в статусе "Черновик"`;
      break;

    // Если статус кандидата == "На проверке"
    case "На проверке":
      isApplyDisabled = candidate.vacancies_candidate_active_count !== "0";
      if (isApplyDisabled) {
        comment = candidate.vacancies_candidate_id_bring_data
          ? "Необходимо довнести данные"
          : "Вы уже откликнулись данным кандидатом";
      }
      break;

    // Если статус кандидата == "Согласован"
    case "Согласован":
      isApplyDisabled = candidate.vacancies_candidate_active_count !== "0";
      if (isApplyDisabled) {
        comment = candidate.vacancies_candidate_id_bring_data
          ? "Необходимо довнести данные"
          : "Вы уже откликнулись данным кандидатом";
      }
      break;

    // Если статус кандидата == "Заблокирован"
    case "Заблокирован":
      isApplyDisabled = true;
      comment = isApplyDisabled
        ? `Нет возможности откликнуться кандидатом в статусе "Заблокирован"`
        : "";
      break;

    default: {
      isApplyDisabled = true;
      comment = "";
    }
  }
  return {
    isApplyDisabled: isApplyDisabled,
    comment: comment
  };
};

export const getReadableFileName = (path) => {
  if (path) {
    const fullName = path.substring(path.lastIndexOf("-") + 1);
    const length = fullName.length;

    const ext = fullName.substring(fullName.lastIndexOf("."));

    if (length <= 9) return fullName;
    else {
      return fullName.slice(0, 5) + ".." + ext;
    }
  } else return "";
};

export const showModalErrorType = async ({ ...data }) => {
  const { id, file, file_name, setFileUploadErrorModal, sendFile } = data;

  if (!isFileAllowed(file)) {
    setFileUploadErrorModal(true);
  } else {
    setFileUploadErrorModal(false);
    await Promise.all([
      sendFile({
        id: id,
        file_name: file_name,
        file: file
      })
    ]);
  }
};

export const showModalErrorTypeSeveral = async ({ ...data }) => {
  const { id, name, filesToSend, setFileUploadErrorModal, sendFile } = data;
  let { idx = 1 } = data;

  let reqs = [];
  let hasRejected = false;

  for (const file of filesToSend) {
    if (!isFileAllowed(file)) {
      hasRejected = true;
    } else {
      reqs.push(
        sendFile({
          id: id,
          file_name: `${name}${idx}`,
          file: file
        })
      );
      idx++;
    }
  }

  setFileUploadErrorModal(hasRejected);

  await Promise.all(reqs);
};

export const FIO = function (candidate, isFullName = false) {
  if (!candidate) return "";
  if (isFullName) {
    return (
      (candidate.surname ?? "") +
      " " +
      (candidate.name ?? "") +
      " " +
      (candidate.patronymic ?? "")
    );
  } else {
    return (
      candidate.surname +
      " " +
      (candidate.name && candidate.name.charAt(0) + ".") +
      (candidate.patronymic ? candidate.patronymic.charAt(0) + "." : "")
    );
  }
};

export const htmlFrom = (htmlString) => {
  const cleanHtmlString = DOMPurify.sanitize(htmlString, {
    USE_PROFILES: { html: true }
  });
  const html = parse(cleanHtmlString);
  return html;
};
